import { axiosInstance } from '../common/api';


export const getUserProfile = async (userId) => {
  const url = `/profile/user/${userId}`;
  return new Promise((resolve, reject) => {
    axiosInstance
      .get(url)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
}

export const upsertUserProfile = async (userId, payload) => {
  const url = `/profile/user/${userId}`;
  return new Promise((resolve, reject) => {
    axiosInstance
      .put(url, payload)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
}

export const createUserProfile = async (userId, payload) => {
  const url = `/profile/user/${userId}`;
  return new Promise((resolve, reject) => {
    axiosInstance
      .post(url, payload)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
}

export default {
  getUserProfile,
  upsertUserProfile,
  createUserProfile,
};


